// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"G9-z"};